import { render, staticRenderFns } from "./dialogue.vue?vue&type=template&id=0b0613cd&scoped=true"
import script from "./dialogue.vue?vue&type=script&lang=js"
export * from "./dialogue.vue?vue&type=script&lang=js"
import style0 from "./dialogue.vue?vue&type=style&index=0&id=0b0613cd&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0613cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b0613cd')) {
      api.createRecord('0b0613cd', component.options)
    } else {
      api.reload('0b0613cd', component.options)
    }
    module.hot.accept("./dialogue.vue?vue&type=template&id=0b0613cd&scoped=true", function () {
      api.rerender('0b0613cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hr/recruiter/dialogue.vue"
export default component.exports